import {useState} from 'react';
import {Button, Col, Modal, Row, Checkbox, Divider} from 'antd';
import {toFSDateTime} from "../../util/timeutils";
import {RowMetricType} from "../../api/Constants";

export const LightUploadModal = ({rows, open, onOk, onCancel, props}) => {
    const [values, setValues] = useState([]);
    const [lightFound, setLightFound] = useState(0);
    const [rowMap, setRowMap] = useState({});
    const [isDelete, setIsDelete] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        // Triggered when reading is complete
        reader.onload = (event) => {
            const text = event.target.result;
            const lines = text.split("\n");
            const parsedValues = [];
            for (let i=1; i<lines.length; i++) {
                const l = lines[i];
                const terms = l.split(",");
                const ts = new Date(terms[0]);
                const val = parseFloat(terms[1]);
                // console.log(`${ts}, ${val}`);
                if ((!isNaN(ts.valueOf())) && (!isNaN(val))) {
                    parsedValues.push({
                        timestamp: ts,
                        value: val,
                    });
                }
            }

            // detect the type
            const terms = lines[0].split(",");
            let found = 0;
            const valueLabel = terms[1].toLowerCase();

            // Full Spectrum specific configuration, Lights1-4 are upper, Lights5 is lower
            if ((valueLabel.includes("lights1")) || (valueLabel.includes("lights2")) || (valueLabel.includes("lights3"))
            || (valueLabel.includes("lights4"))) {
                found = 1;
            } else if (valueLabel.includes("lights5")) {
                found = 2;
            }
            setLightFound(found);

            // console.log(parsedValues);

            if (found > 0) {
                setValues(parsedValues);
            } else {
                setValues([]);
            }
        };
        // Choose format: readAsText, readAsDataURL (for images), or readAsArrayBuffer
        reader.readAsText(file);
    };

    const onRowClick = (row) => (e) => {
        const {id: rowId} = row;
        const nextMap = {...rowMap};
        nextMap[rowId] = e.target.checked;
        setRowMap(nextMap);
    }

    const onSelectAll = () => {
        const nextMap = {};
        rows.forEach(r => {
            const {id: rowId} = r;
            nextMap[rowId] = true;
        })
        setRowMap(nextMap);
    }

    const onModalOk = () => {
        if (onOk) {
            if (lightFound > 0) {
                const lightType = lightFound === 1 ? RowMetricType.UpperLight : RowMetricType.LowerLight;
                onOk(values, rowMap, lightType, isDelete, () => {
                    setRowMap({});
                });
            }
        }
    }

    const onModalCancel = () => {
        if (onCancel) onCancel();
        setRowMap({});
    }

    const onDeleteChecked = (e) => {
        setIsDelete(e.target.checked);
    }

    const rowStyle={
        margin: '5px'
    }

    const labelStyle = {
        marginRight: '5px'
    }

    return <Modal open={open} title={<b>Import Light CSV</b>} onOk={onModalOk} onCancel={onModalCancel} okButtonProps={{disabled: lightFound === 0}} >
        <input type="file" onChange={handleFileChange} />
        {(values.length > 0) && <Divider/>
        }
        {(values.length > 0) && <Row style={rowStyle}>
            <Col style={labelStyle}>
                <b>Values Detected:</b>
            </Col>
            <Col>
                {values.length}
            </Col>
        </Row>
        }
        {(values.length > 0) && <Row style={rowStyle}>
            <Col style={labelStyle}>
                <b>First Value:</b>
            </Col>
            <Col style={labelStyle}>
                {toFSDateTime(values[0].timestamp)}
            </Col>
            <Col>
                {values[0].value}
            </Col>
        </Row>
        }
        {(values.length > 0) && <Row style={rowStyle}>
            <Col style={labelStyle}>
                <b>Last Value:</b>
            </Col>
            <Col style={labelStyle}>
                {toFSDateTime(values[values.length-1].timestamp)}
            </Col>
            <Col>
                {values[values.length-1].value}
            </Col>
        </Row>
        }
        {(lightFound > 0) && <Row style={rowStyle}>
            {(lightFound === 1) ? `Upper Light` : `Lower Light`}
        </Row>
        }
        {(values) && (values.length > 0) && <div>
            <Divider/>
            <Row style={rowStyle}>
                <b>Apply These Values to Rows:</b>
            </Row>
        </div>}
        {(values) && (values.length > 0) && (rows) && (rows.length > 0) && rows.map((r, index) => {
            return <Row key={index}>
                <Checkbox checked={rowMap[r.id]} onClick={onRowClick(r)}>
                    {r.rowName}
                </Checkbox>
            </Row>
        })}
        {(values) && (values.length > 0) && (rows) && (rows.length > 0) &&
            <Row style={rowStyle}>
                <Button onClick={onSelectAll}>Select All</Button>
            </Row>
        }
        <Row style={rowStyle}>
            <Checkbox checked={isDelete} onClick={onDeleteChecked}>Delete</Checkbox>
        </Row>
    </Modal>
}